

export const isDev = false
export function vuetifyConfiguration() {
  const options = JSON.parse('{"theme":{"defaultTheme":"customTheme","themes":{"customTheme":{"dark":false,"colors":{"primary":"#DC0067","secondary":"#004E7C","accent":"#F2F4F8","error":"#B24122","caution":"#FFD221","warning":"#FF5D31","success":"#82BEA0","lightBg":"#C9DEEB","greyText":"#BABABA"}}}},"ssr":true}')
  
  
  
  
  return options
}

